import { PublicGroupStatus } from '../shared/types';

export const getPublicGroupColor = (type: PublicGroupStatus): string =>
  ({ rejected: '#FF4D4F', accepted: '#52C41A', pending: '#1677FF' }[type]);
